import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { InicioPage } from '../pages/inicio.page';

const InicioRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/' element={<InicioPage />} />
    </Routes>
  );
};

export { InicioRoutes };
